/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import { renderErrorMsg } from "../../../assets/component/renderErrorMsg.js";
import ToggleSwitch from "../../../assets/component/ToggleSwitch/ToggleSwitch.js";
import { mapPaymentMethodDataStatus, mapPaymentMethodData } from "../../../assets/helper.js";
import PropTypes from "prop-types";
import UpgradeNoticeCard from "./UpgradeNoticeCard";

const paymentMethods = [
  {
    key: "check_writing",
    label: "Cheque",
  }
];

const defaultFormData = {
  checkWritingOrgName: '',
  checkWritingInstructions: '',
};

class RenderCheckWriting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditMode: false,
      formData: defaultFormData,
    };

    this.handleToggleEditMode = this.handleToggleEditMode.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.mapFormDataFromProps = this.mapFormDataFromProps.bind(this);
    this.mapFieldText = this.mapFieldText.bind(this);
    this.renderErrorMsg = this.renderErrorMsg.bind(this);
  }

  componentDidMount() {
    const newFormData = this.mapFormDataFromProps();

    this.setState({
      formData: newFormData,
    });
  }

  handleToggleEditMode() {
    const { isEditMode } = this.state;

    const newState = !isEditMode;

    if (newState === false) {
      // reset form data when cancel edit
      const newFormData = this.mapFormDataFromProps();
      this.setState({
        formData: newFormData,
      });
    }

    this.setState({
      isEditMode: newState,
    });
  }

  handleInputChange(e) {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  }

  handleSave() {
    const { formData } = this.state;
    const { func } = this.props;

    func.handleUpdatePaymentData(paymentMethods[0].key, paymentMethods[0].label, formData);

    this.setState({ isEditMode: false });
  }

  mapFormDataFromProps() {
    const { state } = this.props;
    const { formData } = this.state;

    let newFormData = formData;

    const paymentCodes = state.organizationObj.paymentMethodCode;

    if (paymentCodes) {
      const getPaymentData = paymentCodes[paymentMethods[0].key] || null;

      if (getPaymentData) {
        // reset to latest data from props
        newFormData = {
          checkWritingOrgName: getPaymentData.checkWritingOrgName || '',
          checkWritingInstructions: getPaymentData.checkWritingInstructions || '',
        };
      } else {
        // reset to default
        newFormData = defaultFormData;
      }
    }

    return newFormData;
  }

  mapFieldText(field)  {
    const { formData } = this.state;

    let text = '-';

    if (formData[field] !== '') {
      text = formData[field];
    }

    return text;
  }

  renderErrorMsg() {
    const { state } = this.props;
    const errMsg = state.errMsgInfo.paymentCode;

    if (errMsg.method === paymentMethods[0].key && !errMsg.isCode) {
      return renderErrorMsg(errMsg.msg);
    }

    return null;
  }

  t(key, fallback) {
    const pmText = (this.props.languageObj && this.props.languageObj.PaymentMethods) || {};
    return pmText[key] || fallback;
  }

  render() {
    const { state, func } = this.props;
    const { isEditMode, formData } = this.state;

    const checkwritingStatus = mapPaymentMethodDataStatus(state.organizationObj.paymentMethodCode, paymentMethods[0].key);
    const checkwritingData = mapPaymentMethodData(state.organizationObj.paymentMethodCode, paymentMethods[0].key);
    // Check Writing is configured if organization name or instructions have data
    const checkwritingIsConfigured = Boolean(checkwritingData.checkWritingOrgName || checkwritingData.checkWritingInstructions);

    if (state.loading) {
      return (
        <div className="RenderCheckWriting-loading">
          <div className="RenderCheckWriting-spinner"></div>
        </div>
      );
    }

    const currentPlan = state.organizationObj.currentPlan
      ? state.organizationObj.currentPlan.toLowerCase()
      : "";
    const isPremiumPlan = currentPlan === "premium";

    if (!isPremiumPlan) {
      return (
        <div className="RenderCheckWriting-container">
          <UpgradeNoticeCard onUpgradeClick={func.redirectToOrgBilling} />
        </div>
      );
    }

    return (
      <div className="RenderCheckWriting-container">
        <div className="RenderCheckWriting-content">
          <div className="RenderCheckWriting-toggleRow">
            <span className="RenderCheckWriting-toggleLabel">{this.t("enableCheque", "Enable Cheque")}</span>
            <ToggleSwitch
              checked={checkwritingStatus.checked}
              onChange={(e) => func.handleUpdatePaymentStatus(e, paymentMethods[0].key)}
              disabled={!checkwritingIsConfigured}
              disabledMessage={!checkwritingIsConfigured ? this.t("fillRequiredFirst", "Please fill in the required fields first") : ""}
            />
          </div>

          <div className="RenderCheckWriting-formContainer">
            <div className="RenderCheckWriting-savedCredentials">

              <div className="RenderCheckWriting-group">
                <div className="RenderCheckWriting-subheading">{this.t("orgNameLabel", "Organization Name")}</div>
                {isEditMode ? (
                  <div className="RenderCheckWriting-inputFieldContainer">
                    <input
                      type="text"
                      name="checkWritingOrgName"
                      className="RenderCheckWriting-inputField"
                      placeholder={this.t("orgNameLabel", "Organization Name")}
                      value={formData.checkWritingOrgName}
                      onChange={this.handleInputChange}
                    />
                  </div>
                ) : (
                  <div className="RenderCheckWriting-textValue">
                    {this.mapFieldText('checkWritingOrgName')}
                  </div>
                )}
              </div>
             
              <div className="RenderCheckWriting-group">
                <div className="RenderCheckWriting-subheading">{this.t("instructions", "Instructions")}</div>
                {isEditMode ? (
                  <div className="RenderCheckWriting-textAreaFieldContainer">
                    <textarea
                      type="text"
                      name="checkWritingInstructions"
                      className="RenderCheckWriting-textAreaField"
                      placeholder={this.t("instructions", "Instructions")}
                      value={formData.checkWritingInstructions}
                      onChange={this.handleInputChange}
                    />
                  </div>
                ) : (
                  <div className="RenderCheckWriting-textValue">
                    {this.mapFieldText('checkWritingInstructions')}
                  </div>
                )}
              </div>

            </div>
          </div>

          {this.renderErrorMsg()}
        </div>
      </div>
    );
  }
}

RenderCheckWriting.propTypes = {
  state: PropTypes.object.isRequired,
  func: PropTypes.object.isRequired,
  languageObj: PropTypes.object,
};

export default RenderCheckWriting;
